var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSwitchLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.13,83.91a58.87,58.87,0,0,0-41.92-17.37H58.79A59.36,59.36,0,0,0-.5,125.84v4.32a59.36,59.36,0,0,0,59.29,59.3H197.21a59.36,59.36,0,0,0,59.29-59.3v-4.32A58.91,58.91,0,0,0,239.13,83.91ZM195,174.68H61a46.68,46.68,0,0,1,0-93.36H195a46.68,46.68,0,0,1,0,93.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.76,91.33A35.22,35.22,0,1,0,97,126.54,35.25,35.25,0,0,0,61.76,91.33Zm0,57.25a22,22,0,1,1,22-22A22.07,22.07,0,0,1,61.76,148.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwitchLeft);
export default __webpack_public_path__ + "static/media/icon-switch-left.b08dff9c.svg";
export { ForwardRef as ReactComponent };